import React from "react";
import { Text } from "@chakra-ui/react";

/**
 * Card-on-file consent line, shown with every pay button.
 *
 * The engine saves the guest's card for later merchant-initiated charges
 * (`setup_future_usage: 'off_session'`) on all guest payment flows, and card
 * networks require the guest to be told that the card is stored and may be
 * charged later. The copy is the canonical CARD_ON_FILE_CONSENT_TEXT from
 * the engine's cardOnFileService — keep the two in sync.
 */
export const CARD_CONSENT_TEXT =
  "Your card is saved securely by Stripe and may be charged for this booking per the host's terms.";

const CardConsentNote = (props) => (
  <Text
    fontSize="10px"
    fontWeight={500}
    opacity={0.45}
    textAlign="center"
    lineHeight="1.4"
    {...props}
  >
    {CARD_CONSENT_TEXT}
  </Text>
);

export default CardConsentNote;
